import { LocalStorageService, provideLocalStorageService } from '@v2/utilities/browser-storage/local-storage';
import { EnvironmentCp } from '../environment-cp';

// eslint-disable-next-line @typescript-eslint/typedef
const apiVersion = (window as any).apiVersion;

export function getEnvironmentCp(devEnvironmentCp: EnvironmentCp, prodEnvironmentCp: EnvironmentCp): EnvironmentCp {
  const localStorageService: LocalStorageService = provideLocalStorageService();
  const cpTask: string | undefined = localStorageService.get('cp-task');
  if (cpTask === undefined) {
    return { ...prodEnvironmentCp, apiVersion };
  }
  if (cpTask.length === 0) {
    return devEnvironmentCp;
  }
  return {
    ...devEnvironmentCp,
    envName: cpTask
  };
}
